import React from "react";
import Button from "components/button";
import Tooltip from "components/tooltips/Tooltips";
import { InformationIcon, Pencil, TrashIcon } from "assets/icons";

const formatWage = (wage) => {
    if (typeof wage !== "number") return "—";
    return new Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(wage);
};

const TemplateCard = ({
    template,
    selectable = false,
    selected = false,
    onSelect,
    onEdit,
    onDelete,
}) => {
    if (!template) return null;
    const isBlocked = template.isBelowMinimumWage;
    const wage = template.salary?.wage_per_hour;

    const handleSelect = () => {
        if (!selectable || isBlocked) return;
        onSelect?.(template);
    };

    return (
        <div
            className={`flex flex-col gap-3 border rounded-xl p-4 bg-white transition-all ${
                isBlocked
                    ? "border-red-200"
                    : selected
                    ? "border-yellow-500 ring-1 ring-yellow-200"
                    : "border-gray-200"
            } ${selectable && !isBlocked ? "cursor-pointer hover:border-gray-300" : ""}`}
            onClick={handleSelect}
        >
            <div className="flex items-start justify-between gap-3">
                <div className="flex flex-col gap-1 min-w-0">
                    <div className="ft-base font-semibold text-gray-900 truncate">
                        {template.name || template.title || "Sans nom"}
                    </div>
                    {template.title && template.name !== template.title && (
                        <div className="ft-sm text-gray-500 truncate">
                            {template.title}
                        </div>
                    )}
                    <div className="flex flex-wrap gap-2 mt-1">
                        {template.activity && (
                            <span className="ft-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-600">
                                {template.activity}
                            </span>
                        )}
                        {template.isIndexedToMinimumWage && (
                            <span className="ft-xs px-2 py-0.5 rounded-full bg-yellow-50 text-yellow-700 border border-yellow-200">
                                Indexé au SMIC
                            </span>
                        )}
                    </div>
                </div>
                <div className="flex flex-col items-end shrink-0">
                    <div className="ft-base font-medium text-gray-900">
                        {formatWage(wage)} €/h
                    </div>
                    {template.location?.city && (
                        <div className="ft-xs text-gray-500">
                            {template.location.city}
                        </div>
                    )}
                </div>
            </div>
            {isBlocked && (
                <div className="flex items-start gap-2 px-3 py-2 rounded-lg bg-red-50 border border-red-200">
                    <div className="mt-0.5">
                        <InformationIcon wh={14} color={"#B91C1C"} />
                    </div>
                    <div className="ft-xs text-red-700">
                        Cette fiche est inférieure au SMIC. Mettez-la à jour
                        avant de l’utiliser pour créer une mission.
                    </div>
                </div>
            )}
            {(onEdit || onDelete) && (
                <div className="flex justify-end gap-2 pt-1">
                    {onEdit && (
                        <Tooltip text={"Modifier"} placement="top">
                            <button
                                type="button"
                                className="p-2 rounded-lg border border-gray-200 hover:bg-gray-50"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onEdit(template);
                                }}
                            >
                                <Pencil wh={16} color={"#374151"} />
                            </button>
                        </Tooltip>
                    )}
                    {onDelete && (
                        <Tooltip text={"Supprimer"} placement="top">
                            <button
                                type="button"
                                className="p-2 rounded-lg border border-gray-200 hover:bg-red-50 hover:border-red-200"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDelete(template);
                                }}
                            >
                                <TrashIcon wh={16} color={"#B91C1C"} />
                            </button>
                        </Tooltip>
                    )}
                </div>
            )}
        </div>
    );
};

export default TemplateCard;
